var App = App || {};

App.SectionTabs = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {

            selector.each(function (index) {
                const section = $(this);
                const select = section.find(".form-select");
                const sectionId = section.attr("id") || index;
                const storageKey = "PowerFI_activeTab_" + window.location.pathname + "_" + sectionId;

                select.on("change", function () {
                    const activeTab = section.find(`[data-bs-toggle=\"tab\"][data-bs-target=\"${$(this).val()}\"]`);
                    if (activeTab.length) {
                        bootstrap.Tab.getOrCreateInstance(activeTab[0]).show();
                    }
                });

                section.on("shown.bs.tab", function (e) {
                    const activeTabTarget = section.find("[data-bs-toggle=\"tab\"].active").attr("data-bs-target");
                    select.val(activeTabTarget);
                    localStorage.setItem(storageKey, activeTabTarget);

                    const params = new URLSearchParams(window.location.search);
                    if (params.has("page")) {
                        params.delete("page");
                        const newSearch = params.toString();
                        const newUrl = window.location.pathname + (newSearch ? "?" + newSearch : "") + window.location.hash;
                        window.location.replace(newUrl);
                    }
                });

                const savedTab = localStorage.getItem(storageKey);
                if (savedTab) {
                    const tabLink = section.find(`[data-bs-toggle=\"tab\"][data-bs-target=\"${savedTab}\"]`);
                    if (tabLink.length) {
                        bootstrap.Tab.getOrCreateInstance(tabLink[0]).show();
                        select.val(savedTab);
                    }
                }
            });
        }
    }

    return {
        Init: Init
    };

})(jQuery);